import React, { useEffect, useMemo } from "react";
import { Checkbox, TextField } from "@material-ui/core";
import { useMainState } from "modules/app/contexts";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import * as S from "./styles";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function FilterOptions({
  setCompanyTeams,
  setUsers,
  setSelectedTags,
  setScope,
  selectedCompanyTeams,
}) {
  const {
    company,
    users,
    tags,
    user,
    filterUsers,
    filterTags,
    filterTeams,
    filterScope,
  } = useMainState();
  const { t } = useTranslation();

  const company_teams = useMemo(
    () =>
      _.orderBy(
        company?.company_teams?.filter((team) =>
          user.company_team_ids.includes(team.id)
        ),
        "name"
      ) || [],
    []
  );

  const employees = useMemo(
    () =>
      _.orderBy(
        users?.filter((employee) => {
          for (const index in user.company_team_ids) {
            const team = user.company_team_ids[index];

            if (employee.company_team_ids.includes(team)) {
              return true;
            }
          }

          return false;
        }),
        "name"
      ) || [],
    []
  );

  const scopeOptions = [
    { name: "all", id: 1, label: t("Contacts:filter.scopeAll") },
    {
      name: "not_interacted",
      id: 2,
      label: t("Contacts:filter.scopeNotInteracted"),
    },
    {
      name: "unread_messages",
      id: 3,
      label: t("Contacts:filter.scopeUnreadMessages"),
    },
  ];

  return (
    <S.Container>
      <S.MultiSelectPicker
        openOnFocus={true}
        id="scope"
        options={scopeOptions}
        getOptionSelected={(option, value) => option.name === value.name}
        getOptionLabel={(scope) => scope.label}
        fullWidth
        onChange={(_event, value) => setScope(value)}
        defaultValue={_.isEmpty(filterScope) ? scopeOptions[0] : filterScope}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("Contacts:filter.scopeLabel")}
            variant="outlined"
          />
        )}
      />

      {user.role === "manager" && (
        <>
          <S.MultiSelectPicker
            id="company-teams"
            multiple
            disableCloseOnSelect
            fullWidth
            options={company_teams}
            noOptionsText={<strong>{t("Contacts:filter.noTeam")}</strong>}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.name}
              </>
            )}
            defaultValue={company_teams?.filter((team) =>
              filterTeams?.includes(team.name)
            )}
            onChange={(_event, value) => setCompanyTeams(value)}
            openOnFocus={true}
            getOptionLabel={(companyTeam) => companyTeam.name}
            limitTags={4}
            getLimitTagsText={(more) =>
              more > 1
                ? t("Contacts:filter.teams", { more })
                : t("Contacts:filter.team", { more })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("Contacts:filter.teamsLabel")}
                variant="outlined"
              />
            )}
          />

          <S.MultiSelectPicker
            id="users"
            multiple
            disableCloseOnSelect
            fullWidth
            options={
              selectedCompanyTeams.length == 0
                ? employees
                : employees.filter((user) => {
                    let existsInCompanyTeam = false;

                    selectedCompanyTeams.forEach((team) => {
                      if (user.company_team_ids.includes(team.id)) {
                        existsInCompanyTeam = true;
                        return;
                      }
                    });

                    return existsInCompanyTeam;
                  })
            }
            noOptionsText={<strong>{t("Contacts:filter.noUser")}</strong>}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.name}
              </>
            )}
            defaultValue={employees?.filter((user) =>
              filterUsers?.includes(user.id)
            )}
            onChange={(_event, value) => setUsers(value)}
            openOnFocus={true}
            getOptionLabel={(user) => user.name}
            limitTags={4}
            getLimitTagsText={(more) =>
              more > 1
                ? t("Contacts:filter.users", { more })
                : t("Contacts:filter.user", { more })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("Contacts:filter.usersLabel")}
                variant="outlined"
              />
            )}
          />
        </>
      )}

      <S.MultiSelectPicker
        id="tags"
        multiple
        disableCloseOnSelect
        fullWidth
        options={tags}
        renderOption={(option, { selected }) => (
          <>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.name}
          </>
        )}
        noOptionsText={<strong>{t("Contacts:filter.noTag")}</strong>}
        defaultValue={tags?.filter((tag) => filterTags?.includes(tag.id))}
        onChange={(_event, value) => setSelectedTags(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("Contacts:filter.tagsLabel")}
            variant="outlined"
          />
        )}
        openOnFocus={true}
        getOptionLabel={(tag) => tag.name}
        limitTags={4}
        getLimitTagsText={(more) =>
          more > 1
            ? t("Contacts:filter.tags", { more })
            : t("Contacts:filter.tag", { more })
        }
      />
    </S.Container>
  );
}

export default FilterOptions;
